/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass, FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSONTyped, FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSON, } from './FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass';
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass(json)) {
        return FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClass(value)) {
        return FxIdWebFeaturesAuthAuthenticateFromGameConnectedDataClassToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromGameResponseConnectedData.js.map